



























































































import { Component, Vue, Watch } from 'nuxt-property-decorator'
import gql from 'graphql-tag'
import BlkOfferProgression from '~/components/offers/BlkOfferProgression.vue'
import BlkMarkdown from '~/components/BlkMarkdown.vue'
import BlkBuyConfirmationModal from '~/components/modals/BlkBuyConfirmationModal.vue'
import BlkReservedPartiallyModal from '~/components/modals/BlkReservedPartiallyModal.vue'
import BlkInvestModal from '~/components/modals/BlkInvestModal.vue'
import BlkApologizeModal from '~/components/modals/BlkApologizeModal.vue'
import BlkCta from '~/components/BlkCta.vue'
import BlkListFiles from '~/components/BlkListFiles.vue'
import { monthDiff } from '~/assets/utils'
import BlkBadge from '@/components/BlkBadge.vue'
import BlkOfferInfo from '@/components/offers/BlkOfferInfo.vue'
import getOfferBannerImg from '@/utils/getOfferBannerImg'
import BlkButton from '@/components/balko-ui/BlkButton.vue'
import { cloneDeep } from 'lodash'
interface ChartDataType {
  name: String
  value: Number
}

interface tickerType {
  __typename: string
  sequenceNumber: number | string
  debtor: any
  state: any
  classification: any
  name: string
}

interface OfferType {
  availableShares: number
  __typename: string
  id: string
  irr: number
  closingDate: string
  description: string
  finalDate: string
  offerName: string
  openDate: string
  title: string
  totalValue: string
  status: string
  minInvestValue: number
  maxInvestValue: number
  increment: number
  hasActiveMetrics: boolean
  amountOfQuotas: number
  offerAnalysis: string
  offerImage: null
  allowedGroups: [string]
  files: Array<any>
  totalPaid: string
  originalIrr: number
  originalFinalDate: string
}

@Component({
  name: 'offersDetails',
  auth: false,
  components: {
    BlkApologizeModal,
    BlkBuyConfirmationModal,
    BlkReservedPartiallyModal,
    BlkCta,
    BlkMarkdown,
    BlkOfferProgression,
    BlkListFiles,
    BlkBadge,
    BlkOfferInfo,
    BlkInvestModal,
    BlkButton
  },
  apollo: {
    offer: {
      query: gql`
        query($offerId: ID!) {
          offer(offerId: $offerId) {
            assets {
              ... on PrecatorioType {
                ticker {
                  debtor
                  state
                  classification
                }
              }
            }
            allowedGroups
            id
            irr
            amountOfQuotas
            availableShares
            closingDate
            description
            finalDate
            maxInvestValue
            minInvestValue
            offerAnalysis
            offerImage
            offerName
            openingDate
            status
            title
            totalValue
            files {
              description
              fileName
              s3Key
              public
            }
            totalPaid
            increment
            originalIrr
            originalFinalDate
            referralCode
          }
        }
      `,
      /* istanbul ignore next */
      variables() {
        return { offerId: this.$route.params.id }
      }
    }
  }
})
export default class extends Vue {
  amountValue: string | null = null
  openOffer: boolean = false
  investModalOpen: boolean = false
  reservedId: string = ''

  offer: OfferType = {
    __typename: '',
    id: '',
    irr: 0,
    closingDate: '',
    description: '',
    finalDate: '',
    offerName: '',
    openDate: '',
    title: '',
    totalValue: '',
    status: '',
    minInvestValue: 0,
    maxInvestValue: 0,
    increment: 0,
    hasActiveMetrics: false,
    amountOfQuotas: 0,
    availableShares: 0,
    offerAnalysis: '',
    offerImage: null,
    allowedGroups: [''],
    files: [],
    totalPaid: '',
    originalIrr: 0,
    originalFinalDate: ''
  }

  formattedFields = {
    closingDate: '',
    minInvestValue: '',
    maxInvestValue: '',
    increment: '',
    irr: '',
    months: 0,
    liquidation: '',
    availableAmount: '',
    finalDate: '',
    distributedTotal: '',
    totalPaid: '',
    originalIrr: '',
    originalFinalDate: ''
  }

  get description() {
    return this.offer.description
      ? this.offer.description
      : this.$root.$tc('offers.offerDetails.notInformed')
  }

  scrollTo(x: number, y: number) {
    window.scrollTo(x, y)
  }

  get analysis() {
    return this.offer.offerAnalysis
      ? this.offer.offerAnalysis
      : this.$root.$tc('offers.offerDetails.notInformed')
  }

  get isExclusiveOffer() {
    return this.offer.allowedGroups?.includes('not-investor')
  }
  @Watch('offer')
  onOfferChange() {
    if (this.offer) {
      if (this.offer.status === 'open') {
        this.openOffer = true
      }

      const increment = this.offer.increment
      const minInvestVal = this.formatValue(this.offer.minInvestValue)
      const maxInvestVal = this.formatValue(this.offer.maxInvestValue)
      const inc = this.formatValue(increment)
      const availableAm = this.formatValue(
        this.offer.availableShares * increment
      )
      const distributedTotal = this.formatValue(
        this.offer.amountOfQuotas * increment
      )
      const totalPaid = this.formatValue(parseInt(this.offer.totalPaid))

      this.formattedFields = {
        closingDate: this.$d(
          new Date(this.offer.closingDate + 'T00:00:00'),
          'default'
        ),
        minInvestValue: minInvestVal ? minInvestVal.toString() : '',
        maxInvestValue: maxInvestVal ? maxInvestVal.toString() : '',
        increment: inc ? inc.toString() : '',
        irr: ((this.offer.irr as number) * 100).toFixed(1) + '%',
        months: monthDiff(new Date(), this.offer.finalDate),
        liquidation: this.$d(
          new Date(this.offer.finalDate + 'T00:00:00'),
          'short'
        ),
        availableAmount: availableAm ? availableAm.toString() : 'R$ 0,00',
        finalDate: this.$root.$d(new Date(this.offer.finalDate), 'default'),
        distributedTotal: distributedTotal
          ? distributedTotal.toString()
          : 'R$ 0,00',
        totalPaid: totalPaid ? totalPaid.toString() : 'R$ 0,00',
        originalIrr:
          ((this.offer.originalIrr as number) * 100).toFixed(1) + '%',
        originalFinalDate: this.$root.$d(
          new Date(this.offer.originalFinalDate),
          'default'
        )
      }
    }
  }

  // cleanAmount only exist for tests pourpose, once idk why but on jest i'm not able to know how to access cleanValue (computed)
  cleanAmount: number = 0

  valueWarning: string = ''
  inputMask: string | undefined = '###########'
  buttonDisable: boolean = true
  reservedValue: number = 0

  /**
   * formatValue.
   *
   * @param {number} value - The value typed by the user
   * @return {string} R$ {value},00
   *
   * @example
   *
   *     validateValue(123)
   */
  formatValue(value: number) {
    if (value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value)
    }
  }

  getOfferBannerImg = getOfferBannerImg

  get cleanValue() {
    if (this.amountValue) {
      this.cleanAmount = parseInt(this.amountValue.replace(/\./g, ''))
      return this.amountValue.replace(/\./g, '')
    } else return 0
  }

  /**
   * validateValue.
   *
   * @param {number} value - The value typed by the user
   *
   * @example
   *
   *     validateValue(123)
   */
  validateValue(value: number | null) {
    // this.inputMask = getMask(value)
    this.buttonDisable = true

    if (this.cleanValue < this.offer.minInvestValue) {
      this.valueWarning =
        this.$root.$tc('openDealCard.higherThanMin') +
        this.formatValue(this.offer.minInvestValue)
    } else if (this.cleanValue > this.offer.maxInvestValue) {
      this.valueWarning =
        this.$root.$tc('openDealCard.lowerThanMax') +
        this.formatValue(this.offer.maxInvestValue)
    } else if ((this.cleanValue as number) % this.offer.increment !== 0) {
      this.valueWarning =
        this.$root.$tc('openDealCard.multipleOfIncrement') +
        this.formatValue(this.offer.increment)
    } else if (!this.$store.state?.me?.isVerifiedByAdmin) {
      this.valueWarning = this.$root.$tc('openDealCard.notVerifiedByAdmin')
    } else if (
      !this.$store.state?.me?.groups.some((r: string) =>
        this.offer?.allowedGroups?.includes(r)
      )
    ) {
      this.valueWarning = this.getOfferAllowedGroupsText()
    } else {
      this.valueWarning = ''
      this.buttonDisable = false
    }
  }

  getOfferAllowedGroupsText() {
    const that = this
    let groups = ' '
    let separator = ''
    this.offer.allowedGroups.forEach(function(group, i) {
      if (i > 0 && i <= that.offer.allowedGroups.length - 1) {
        separator = ', '
      }
      groups += separator + that.$root.$tc('openDealCard.' + group)
    })
    return this.$root.$tc('openDealCard.groupNotAllowed').concat(groups)
  }

  showConfirmationModal(value: string) {
    this.amountValue = value
    this.$bvModal.show('modal-buy-confirmation')
  }

  buyOffer() {
    this.investModalOpen = false
    this.$loadingScreen.show = true
    this.$apollo
      .mutate({
        mutation: gql`
          mutation($offerId: ID!, $amount: Decimal!) {
            reserveShares(offerId: $offerId, amount: $amount) {
              reserved
              status
              id
            }
          }
        `,
        variables: {
          offerId: this.offer.id,
          amount: this.cleanValue
        }
      })
      .then((res) => {
        this.giveFeedback(res)
      })
      .catch((err) => {
        this.$root.$bvToast.toast(this.$tc('offers.alerts.errorMessage'), {
          title: this.$tc('offers.alerts.error'),
          variant: 'danger',
          solid: true
        })
      })
      .finally(() => {
        this.$loadingScreen.show = false
      })
  }

  giveFeedback(res: any) {
    const { status, id } = res.data.reserveShares
    this.reservedId = id

    let showToast = true
    let title = ''
    let content = ''
    let variant = ''

    switch (status) {
      case 'reserved':
        title = this.$tc('offers.alerts.success')
        content = this.$tc('offers.alerts.offerAcquired')
        variant = 'primary'
        break
      case 'user_max_reserved':
        title = this.$tc('offers.alerts.maxReserved')
        content = this.$tc('offers.alerts.maxReservedMessage')
        variant = 'danger'
        break
      case 'sold_out':
        showToast = false
        this.$bvModal.show('modal-apologize-sold-out')
        this.$apollo.queries.offer.refetch()
        break
      case 'partially_reserved':
        showToast = false
        this.reservedValue = parseInt(res.data.reserveShares.reserved)
        this.$bvModal.show('modal-partially-reserved')
        break
      case 'user_not_allowed':
        title = this.$tc('offers.alerts.error')
        content = this.$tc('offers.alerts.notAllowed')
        variant = 'danger'
        break
      default:
        title = this.$tc('offers.alerts.error')
        content = this.$tc('offers.alerts.errorMessage')
        variant = 'danger'
        this.$apollo.queries.offer.refetch()
    }

    if (showToast) {
      if (status === 'reserved') {
        this.$router.push({
          path: `/reservations/${id}?reservation=success`
        })
      } else {
        this.$root.$bvToast.toast(content, {
          title,
          variant,
          solid: true
        })
      }
    }
  }

  loginRedirect() {
    this.$auth.$storage.setUniversal(
      'redirect',
      `/offers/${this.$route.params.id}`
    )
    this.$auth.loginWith('auth0')
  }

  get isPaid() {
    return this.offer.status === 'paid'
  }
}
